// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterItem_wrapper__jFJjm","title":"FilterItem_title__u6C7l","icon":"FilterItem_icon__sQE-b","body":"FilterItem_body__lv1qV","dropdown":"FilterItem_dropdown__EUz71"};